import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

import { SupplierContact } from './../Models/supplierContact';
import { SupplierList } from './../Models/supplierList';
import { SupplierServices } from './supplier.services';

@Injectable()
export class SupplierListResolver {
    constructor(private backend: SupplierServices) { }
    resolve(): Observable<SupplierList[]> {
        return this.backend.getAll();
    }
}
@Injectable()
export class ActiveSupplierResolver {
    constructor(private backend: SupplierServices) { }
    resolve(): Observable<SupplierList[]> {
        return this.backend.getActiveSuppliers();
    }
}

@Injectable()
export class SupplierEditResolver {
    constructor(private backend: SupplierServices) { }
    resolve(route: ActivatedRouteSnapshot) {
        return this.backend.getById(+route.params['supplierId']);
    }
}

@Injectable()
export class SupplierContactResolver {
    constructor(private backend: SupplierServices) { }
    resolve(route: ActivatedRouteSnapshot) {
        return this.backend.getContactType();
    }
}

@Injectable()
export class SupplierContactListResolver {
    constructor(private backend: SupplierServices) { }
    resolve(route: ActivatedRouteSnapshot): Observable<SupplierContact[]> {
        return this.backend.getSupplierContactListById(
            isNaN(+route.params['supplierId']) ? 0 : +route.params['supplierId']
        );
    }
}
